import { jsx as _jsx } from "react/jsx-runtime";
import { Selector, Util } from 'ui-lib';
import { VerificationMethodType } from 'lib/api/api-types';
import * as React from 'react';
export function VerificationMethodTypeSelector(props) {
    var choices = Util.idNamePairsFromEnum(VerificationMethodType);
    return _jsx(Selector, { disabled: props.disabled, name: props.name, items: choices, label: "Verification Method Type" });
}
